<template>
  <page class="home-page">
    <zui-header>
      <logo type="xiaoyanyun" href="/"></logo>
      <h4 class="zui-logo-text">
        |&nbsp;&nbsp;国潮国色 让爱美丽
        <br/>|&nbsp;&nbsp;让家健康 让社会更美好
      </h4>
      <el-dropdown class="zui-rightcol" @command="handleCommand" trigger="click">
        <span class="el-dropdown-link">
          网站导航<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <template v-for="(zbtn,zi) in headBtn">
                <el-dropdown-item :command="zbtn.key" :key="zi">{{zbtn.text}}</el-dropdown-item>
            </template>
        </el-dropdown-menu>
      </el-dropdown>
    <template v-for="(zbtn,zi) in headBtn">
        <zui-button @click="onButtonClick(zbtn.key)" :key="zi" :class="activeFlag(zbtn.key)?'active':''">{{zbtn.text}}</zui-button>
    </template>
    </zui-header>

    <div id="wrapper" class="pcWrapper">
      <!--focus start-->
      <div id="FocusBG" class="pcFocusBG joinFocusBG">
        <img src="../assets/img/join/an_bg.jpg" class="inside_top_bg">
      </div>


      <!--focus end-->
      <!--body start-->
      <div id="body">
        <!--inner start -->
        <div class="inner">
          <!--right start-->
          <div class="right">
            <div class="PosLeft">公司介绍</div>
            <!--main start-->
            <div class="main">

              <!--content start-->
              <div class="content">
                <div class="maincontent clearfix">
                  <nav>
                    <p style="text-indent:2em;">
                      上海珂立诺新材料科技有限公司是一家集研发、生产、销售、设计、施工于一体的墙面定制企业。秉承着“以人为本，以改变生活为宗旨”，不断提升舒适的空间生活品质。并结合多种艺术美学形式，以独特、原创、可持续的发展理念，创办符合当代家居美学的“珂立诺”艺术涂料品牌。
                    </p>
                    <p style="text-indent:2em;">
                      艺术涂料源于艺术，又不仅仅局限于艺术。最早起源于欧洲，在20世纪进入中国，并在广东顺德迅速发展。因此，广东顺德便有了“艺术涂料之乡”的美称！“珂立诺”艺术涂料正是看中了“艺术涂料之乡”与生俱来的艺术氛围和创新气息，于2013年，将总部设立在广东顺德勒流镇内。
                    </p>
                    <p style="text-indent:2em;">
                      “珂立诺”艺术涂料品牌创始人，凭借其十余年的艺术涂料“深耕”经验，将最鲜明的“创新服务”品牌印记和“工匠传承”时代精神，设为品牌立足之根本，为当代空间注入不一样的家庭情怀和艺术气息。并将艺术涂料的环保、健康、款式多样、色彩新颖的特点，带进万千家庭！目前，公司已拥有“卡玛拉”、“巴黎缤纷”、“贵族莎绒”、“金属丝绒”等数十款艺术涂料细分产品。凭借着产品“硬度高”、“修补力强”、“耐刮擦”、“防霉防潮”等特性，迅速占领市场，得到了广大消费者的一致好评，全国服务用户已超5万+，使用单位更是包括：美的、碧桂园、保利、万科等全球知名品牌。
                    </p>
                    <p style="text-indent:2em;">
                      “珂立诺”艺术涂料致力于为消费者提供简约、时尚、高品质的艺术涂料产品，打造非凡的空间享受！不仅全系列产品法国A+检测认证，而且与红星美凯龙、居然之家、欧亚达、宜家家居等一线知名机构建立了长期战略合作关系。“珂立诺”艺术涂料坚持以国际前瞻的视野，洞察设计潮流的趋势，通过“绿色”原料的把控和严格检测的质量体系，使每一位消费者都得到时尚和优质的产品体验，赢得了广大消费者对“珂立诺”产品的高度认可，同时也是精品连锁工程，写字楼，文旅地产项目的首选品牌之一。
                    </p>
                    <br>
                    <img src="/images/image/20221020104895889588.jpg" alt=""><br>
                    <table width="100%" border="0" cellpadding="0" cellspacing="0" class="ke-zeroborder">
                      <tbody>
                      <tr>
                        <td height="78" align="center">
				<span><span><span><span class="indexa2Hbreen26red">品牌优势</span><br>
<span class="intro14">BRAND ADVANTAGES</span> </span> </span> </span>
                        </td>
                      </tr>
                      <tr>
                        <td align="center">
                          <p class="intro18">
					<span><span><span>珂立诺艺术涂料——专注高端艺术涂料及配套产品的研发生产<br>
凭借先进的生产工艺，引进意大利技术配方，<br>
承载进口原材料专业的施工团队，<br>
将独具艺术魅力的产品和服务带给广大业主</span> </span> </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td align="center">
                          <div class="inhon">
                            <ul>
                              <li>
                                <span><span><img src="../assets/img/company/3.jpg"> </span> </span>
                              </li>
                              <li>
                                <span><span><img src="../assets/img/company/6.jpg"> </span> </span>
                              </li>
                              <li>
                                <span><span><img src="../assets/img/company/3.jpg"> </span> </span>
                              </li>
                              <li>
                                <span><span><img src="../assets/img/company/6.jpg"> </span> </span>
                              </li>
                            </ul>
                          </div>
                          <span><span><span><img src="../assets/img/company/20220723161885658565.jpg" alt=""><br>
</span> </span> </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span><span><span>&nbsp;</span> </span> </span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="clearfix"></div>
                  </nav>
                </div>


              </div>
              <!--content end-->

            </div>
            <!--main end-->
          </div>
          <!--right end-->
          <div class="clearfix"></div>
        </div>
        <!--inner end-->
      </div>
      <!--body end-->
      <div class="HeightTab clearfix"></div>

    </div>

    <zui-footer/>
  </page>
</template>
<script>
  import '../assets/css/quanping.css'
  import '../assets/less/home-page.less'
  import Logo from '../components/portal/Logo'
  import Page from '../components/portal/Page'
  import ZuiHeader from '../components/portal/Header'
  import ZuiFooter from '../components/portal/Footer'
  import ZuiButton from '../components/portal/Button'
  import Util from '../Util'
  export default{
    components: {
      Page, Logo, ZuiHeader, ZuiFooter,ZuiButton
    },
    data () {
      return {
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2
      }
    },
    methods: {
    }
  }
</script>
<style>
  .c1{
    width: 80%;
    margin: 0 auto;
  }
</style>
